import clsx from "clsx";
import React, { FC } from "react";

import { ReactComponent as BiesseLogoBicolorDark } from "../../images/biesse-logo-bicolor-dark.svg";
import { ReactComponent as BiesseLogoBicolorLight } from "../../images/biesse-logo-bicolor-light.svg";
import { ReactComponent as BiesseLogoMonochrome } from "../../images/biesse-logo.svg";
import { getResolvedThemeColors } from "../../styles/resolved-config";
import { MaterialType } from "../../types/materials";

export interface BiesseLogoProps {
  material?: MaterialType;
  className?: string;
  monochrome?: boolean;
  color?: "black" | "white";
}

export const BiesseLogo: FC<BiesseLogoProps> = ({
  material,
  className,
  monochrome,
  color = "black",
}) => {
  const typedMaterial = material as MaterialType;
  const BiesseLogoBicolor = color === "black" ? BiesseLogoBicolorDark : BiesseLogoBicolorLight;
  const BiesseLogoComponent = monochrome ? BiesseLogoMonochrome : BiesseLogoBicolor;
  const themeColors = getResolvedThemeColors();
  const materialColor = themeColors[typedMaterial];

  return (
    <BiesseLogoComponent
      height={65}
      style={{ color: monochrome ? undefined : materialColor }}
      className={clsx(
        "mb-[1px]",
        {
          "text-dark": color === "black" && monochrome,
          "text-light": color === "white" && monochrome,
        },
        className
      )}
    />
  );
};
